(() => {
  if (document.querySelector("sp-drip-builder")) return;
  const productHandle = location.pathname.split('/').filter(Boolean).pop();
  const dripHandles = new Set([
    'drip-nutella-smashcake', 'drip-gumball-smashcake', 'drip-reeses-pieces-smashcake',
    'drip-chocoholic-smashcake', 'drip-simple-simon-smashcake', 'drip-top-deck-smashcake',
    'drip-pastel-smashcake', 'drip-strawberries-and-cream-smashcake', 'drip-rocky-road-smashcake',
    'drip-pink-smashcake', 'drip-minty-smashcake', 'drip-gumball-smashcake-1',
    'rose-gold-blush-drip-smashcake'
  ]);
  const smashBoxHandles = new Set([
    'smashbox', 'mums-smashbox', 'easter-smashbox', 'halloween-smashbox',
    'dads-smashbox', 'gender-reveal-smashbox', 'christmas-smashbox', 'thank-you-smashbox'
  ]);
  const domeHandles = new Set([
    'dome-nutella-smashcake', 'dome-goldrush-smashcake',
    'dome-candycrush-smashcake', 'copy-of-dome-candycrush-smashcake',
    'copy-of-dome-candycrush-smashcake-1', 'copy-of-dome-candycrush-smashcake-2',
    'copy-of-dome-candycrush-smashcake-3', 'copy-of-dome-candycrush-smashcake-4'
  ]);
  const domePaletteHandles = new Set([
    'dome-candycrush-smashcake',
    'copy-of-dome-candycrush-smashcake-1',
    'copy-of-dome-candycrush-smashcake-2',
    'copy-of-dome-candycrush-smashcake-4'
  ]);

  const numberHandles = new Set(['numbers-candy-smashcake']);
  const sayItHandles = new Set([
    'candycrush-say-it-on-a-cake', 'say-it-on-a-cake',
    'chocoholic-say-it-on-a-cake', 'allsorts-say-it-on-a-cake'
  ]);
  const isSayItCollection = location.pathname.replace(/\/$/, '') === '/collections/say-it-on-a-cake';
  const isSmashBox = smashBoxHandles.has(productHandle);
  const isDome = domeHandles.has(productHandle);
  const isDomePalette = domePaletteHandles.has(productHandle);
  const isSayIt = sayItHandles.has(productHandle);
  const isNumberCake = numberHandles.has(productHandle);
  if (isSayItCollection) {
    const mountHero = () => {
      if (document.querySelector('.say-it-hero')) return true;
      const heading = document.querySelector('h1');
      if (!heading) return false;
      const hero = document.createElement('section');
      hero.className = 'say-it-hero';
      hero.innerHTML = '<div class="say-it-hero__image"><img src="https://cdn.shopify.com/s/files/1/0598/5524/1375/files/say-it-on-a-cake-clean-cutout.png?v=1789452788" alt="Personalised Say It on a Cake SmashCake with chocolate letters, colourful lollies and wooden hammer"></div><div class="say-it-hero__copy"><p>Your words. Your colours. Your SmashCake.</p><h2>Say it on a cake.</h2><span>Two lines. Seven letters each. One very sweet surprise.</span></div>';
      heading.insertAdjacentElement('afterend', hero);
      return true;
    };
    ready(mountHero);
    return;
  }
  if (!dripHandles.has(productHandle) && !isSmashBox && !isDome && !isSayIt && !isNumberCake) return;
  const colourMode = isSmashBox
    ? 'shell'
    : productHandle === 'drip-pastel-smashcake' || productHandle === 'drip-gumball-smashcake'
      ? 'both'
      : productHandle === 'disco-smashcake'
        ? 'shell'
        : 'none';
  const isCandyCrush = productHandle === 'drip-pastel-smashcake';

  const ready = (callback) => {
    if (callback()) return;
    const observer = new MutationObserver(() => {
      if (callback()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  const titleForColour = (title, index, total) => {
    const cleanTitle = (title || 'colour').replace(/^\d+\.\s*/, '').trim();
    if (isSmashBox) return index === 0 ? '1. Pick your SmashBox colour' : (index + 1) + '. Choose your ' + cleanTitle.toLowerCase();
    if (isDome) return index === 0 ? '1. Pick your chocolate shell' : (index + 1) + '. Choose your ' + cleanTitle.toLowerCase();
    if (isCandyCrush) return index === 0 ? '1. Pick your chocolate shell' : '2. Make it drip';
    if (total > 1 && index === 0) return '1. Pick your chocolate shell';
    if (/drip/i.test(cleanTitle)) return total > 1 ? '2. Make it drip' : 'Make it drip';
    if (/letter|text|word/i.test(cleanTitle)) return total > 1 ? '2. Choose your lettering' : 'Choose your lettering colour';
    if (/base|shell|chocolate/i.test(cleanTitle)) return total > 1 ? '1. Pick your chocolate shell' : 'Pick your chocolate shell';
    return total > 1 ? (index + 1) + '. Choose your ' + cleanTitle.toLowerCase() : 'Pick your ' + cleanTitle.toLowerCase();
  };

  const hintForColour = (title, index, total) => {
    if (isSmashBox) return index === 0 ? 'Pick from our fresh, fun colour palette.' : 'Choose the finishing detail that brings your SmashBox to life.';
    if (isDome) return index === 0 ? 'Choose a colour to start the magic.' : 'Pick the finishing detail that makes it yours.';
    if (isCandyCrush) return index === 0 ? 'Choose a colour to start the magic.' : 'Go matching or choose a delicious contrast.';
    if (total > 1 && index === 0) return 'Choose a colour to start the magic.';
    if (/drip/i.test(title)) return 'Go matching or choose a delicious contrast.';
    if (/letter|text|word/i.test(title)) return 'Pick a colour that pops.';
    return 'Choose the colour that brings this SmashCake to life.';
  };

  const enhancePalette = () => {
    const root = document.querySelector('.best-custom-product-options');
    if (!root) return false;
    const groups = Array.from(root.querySelectorAll('.selector-wrapper.bcpo-colors'));
    // The product-options app injects its colour groups after its outer form.
    // Keep watching until they are actually available instead of treating the
    // empty shell as ready.
    if (!groups.length) return false;
    root.classList.add('candy-crush-builder');

    const sizeSelect = root.querySelector('#bcpo-select');
    const sizeGroup = sizeSelect?.closest('.selector-wrapper');
    const sizeTitle = sizeGroup?.querySelector('.bcpo-title');
    if (sizeTitle && !sizeTitle.dataset.builderReady) {
      sizeTitle.textContent = isSmashBox ? 'Choose your SmashBox size' : 'Choose your SmashCake size';
      sizeTitle.dataset.builderReady = 'true';
    }

    groups.forEach((group, index) => {
      if (group.dataset.candyCrushReady === 'true') return;
      const originalTitle = group.querySelector('.bcpo-title')?.textContent || 'colour';
      const kind = /drip/i.test(originalTitle) ? 'drip' : index === 0 ? 'shell' : 'colour';
      const title = group.querySelector('.bcpo-title');
      if (title) {
        title.textContent = titleForColour(originalTitle, index, groups.length);
        const hint = document.createElement('span');
        hint.className = 'candy-crush-builder__hint';
        hint.textContent = hintForColour(originalTitle, index, groups.length);
        title.insertAdjacentElement('afterend', hint);
        const choice = document.createElement('div');
        choice.className = 'candy-crush-builder__choice';
        choice.innerHTML = '<span class="candy-crush-builder__choice-dot"></span><span>Your ' + kind + ': Choose a colour</span>';
        hint.insertAdjacentElement('afterend', choice);
      }

      const native = group.querySelector('.single-option-selector');
      if (!native) return;
      native.classList.add('candy-crush-builder__native');
      const palette = document.createElement('div');
      palette.className = 'candy-crush-builder__palette';
      const update = () => {
        const chosen = group.querySelector('.bcpo-front-color-option:checked');
        palette.querySelectorAll('.candy-crush-builder__option').forEach((button) => {
          button.classList.toggle('is-selected', button.dataset.target === chosen?.id);
        });
        const label = chosen?.parentElement.querySelector('.bcpo-front-color-label');
        const choice = group.querySelector('.candy-crush-builder__choice');
        if (chosen && label && choice) {
          const colour = label.style.background || label.style.backgroundColor || getComputedStyle(label).backgroundColor;
          choice.querySelector('.candy-crush-builder__choice-dot').style.background = colour;
          choice.querySelector('span:last-child').textContent = 'Your ' + kind + ': ' + chosen.value;
        }
      };

      group.querySelectorAll('.bcpo-color-parent').forEach((swatch) => {
        const input = swatch.querySelector('.bcpo-front-color-option');
        const label = swatch.querySelector('.bcpo-front-color-label');
        if (!input || !label) return;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'candy-crush-builder__option';
        button.dataset.target = input.id;
        const dot = document.createElement('span');
        dot.className = 'candy-crush-builder__option-dot';
        dot.style.background = label.style.background || label.style.backgroundColor || getComputedStyle(label).backgroundColor;
        const name = document.createElement('span');
        name.textContent = input.value;
        button.append(dot, name);
        if (/dream|other|notes/i.test(input.value)) button.classList.add('candy-crush-builder__option--dream');
        button.addEventListener('click', () => {
          input.click();
          update();
        });
        input.addEventListener('change', update);
        palette.appendChild(button);
      });
      native.insertAdjacentElement('afterend', palette);
      update();
      group.dataset.candyCrushReady = 'true';
    });
    return true;
  };

  const getProperties = (form) => {
    const properties = {};
    if (!form) return properties;
    new FormData(form).forEach((value, key) => {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && String(value).trim()) properties[match[1]] = value;
    });
    return properties;
  };


  const fallbackColours = [
    ['Choc Classic', '#a56a28'], ['Snow Pop', '#f7f5ef'], ['Fairy Floss', '#df98d0'],
    ['Electric Pink', '#eb27c9'], ['Sky Splash', '#62b2d9'], ['Blue Razz', '#3b39d9'],
    ['Jungle Jolt', '#55ab3f'], ['Lolly Lime', '#9ce936'], ['Cherry Pop', '#df3043'],
    ['Orange Sherbet', '#ef6d2a'], ['Lemon Fizz', '#fae84d'], ['Grape Pop', '#9851dc'],
    ['Aqua Pop', '#6bcbd2'], ['Midnight Magic', '#151515']
  ];

  const fallbackPalette = (heading, hint, property) => {
    const group = document.createElement('section');
    group.className = 'selector-wrapper bcpo-colors candy-crush-builder__fallback-colours';
    group.innerHTML = '<span class="bcpo-label"><strong class="bcpo-title"></strong></span><span class="candy-crush-builder__hint"></span><div class="candy-crush-builder__choice"><span class="candy-crush-builder__choice-dot"></span><span>Choose a colour</span></div><input type="hidden" name="properties[' + property + ']" value=""><div class="candy-crush-builder__palette"></div><button type="button" class="candy-crush-builder__option candy-crush-builder__option--dream"><span class="candy-crush-builder__option-dot"></span><span>Dream Colour — add in notes</span></button>';
    group.querySelector('.bcpo-title').textContent = heading;
    group.querySelector('.candy-crush-builder__hint').textContent = hint;
    const hidden = group.querySelector('input[type="hidden"]');
    const choice = group.querySelector('.candy-crush-builder__choice');
    const palette = group.querySelector('.candy-crush-builder__palette');
    const choose = (name, colour, button) => {
      hidden.value = name;
      hidden.setAttribute('value', name);
      hidden.dispatchEvent(new Event('change', { bubbles: true }));
      palette.querySelectorAll('.candy-crush-builder__option').forEach((item) => item.classList.remove('is-selected'));
      group.querySelector('.candy-crush-builder__option--dream').classList.remove('is-selected');
      button?.classList.add('is-selected');
      choice.querySelector('.candy-crush-builder__choice-dot').style.background = colour || '#fff';
      choice.querySelector('span:last-child').textContent = 'Your colour: ' + name;
    };
    fallbackColours.forEach(([name, colour]) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'candy-crush-builder__option';
      button.innerHTML = '<span class="candy-crush-builder__option-dot"></span><span></span>';
      button.querySelector('.candy-crush-builder__option-dot').style.background = colour;
      button.querySelector('span:last-child').textContent = name;
      button.addEventListener('click', () => choose(name, colour, button));
      palette.appendChild(button);
    });
    group.querySelector('.candy-crush-builder__option--dream').addEventListener('click', (event) => {
      choose('Dream Colour — add in notes', '#fff', event.currentTarget);
    });
    return group;
  };

  const makeFallbackBuilder = async () => {
    const root = document.querySelector('.best-custom-product-options');
    const appForm = root?.querySelector('form');
    const productForm = document.querySelector('.js-product-form');
    if (!productForm) return false;



    if (document.querySelector('.candy-crush-builder__fallback-size')) return true;
    try {
      const product = await fetch(location.pathname + '.js').then((response) => {
        if (!response.ok) throw new Error('Product data unavailable');
        return response.json();
      });
      const variants = product.variants || [];
      if (!variants.length) return false;
      const party = variants.find((variant) => /party popper/i.test(variant.title)) || variants[0];
      const idInput = productForm.querySelector('[name="id"]') || (() => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'id';
        productForm.prepend(input);
        return input;
      })();
      const box = document.createElement('section');
      box.className = 'candy-crush-builder candy-crush-builder__fallback-size';
      box.innerHTML = '<label class="bcpo-label"><strong class="bcpo-title">Choose your SmashCake size</strong><select class="candy-crush-builder__size-select"></select></label>';
      const select = box.querySelector('select');
      variants.forEach((variant) => {
        const option = document.createElement('option');
        option.value = variant.id;
        option.textContent = variant.title;
        option.selected = variant.id === party.id;
        select.appendChild(option);
      });
      const syncVariant = () => {
        const variant = variants.find((item) => String(item.id) === String(select.value)) || party;
        idInput.value = variant.id;
        document.querySelectorAll('.price__current .js-value').forEach((price) => {
          price.textContent = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(variant.price / 100);
        });
      };
      syncVariant();
      select.addEventListener('change', syncVariant);
      document.addEventListener('submit', (event) => {
        if (event.target === productForm) idInput.value = select.value;
      }, true);
      const quantity = productForm.querySelector('[name="quantity"]')?.closest('.quantity-submit-row') || productForm.querySelector('[name="quantity"]');
      if (quantity) quantity.insertAdjacentElement('beforebegin', box);
      else productForm.prepend(box);
      if (colourMode !== 'none') {
        const shell = fallbackPalette('1. Pick your chocolate shell', 'Choose a colour to start the magic.', '1. Pick your chocolate shell');
        box.append(shell);
        if (colourMode === 'both') {
          const drip = fallbackPalette('2. Make it drip', 'Go matching or choose a delicious contrast.', '2. Make it drip');
          box.append(drip);
        }
      }
      return true;
    } catch (error) {
      return false;
    }
  };




  const mountNumberHero = () => {
    if (document.querySelector('.number-hero')) return true;
    const title = document.querySelector('h1, .product-title');
    const productArea = title?.closest('[id^="shopify-section-"]') || document.querySelector('.product-area') || document.querySelector('.product-detail')?.parentElement || document.querySelector('main')?.firstElementChild;
    if (!productArea) return false;
    document.querySelectorAll('.main-product-media, .product-media, .product-gallery, .product-detail__media, [data-media-gallery], [data-product-media]').forEach((media) => {
      media.style.setProperty('display', 'none', 'important');
      media.setAttribute('aria-hidden', 'true');
    });
    const hero = document.createElement('section');
    hero.className = 'number-hero';
    hero.innerHTML = '<div class="number-hero__image"><img src="https://cdn.shopify.com/s/files/1/0598/5524/1375/files/number-smashcake-rainbow-8-studio-hero.png?v=1789521189" alt="Rainbow Number 8 SmashCake with lollies and wooden hammer on a soft blue studio background"></div><div class="number-hero__copy"><p>NUMBER SMASHCAKES</p><h2>Big number.<br>Bigger smash.</h2><span>Choose your colour, choose your number, then smash into the surprise inside.</span></div>';
    productArea.insertAdjacentElement('beforebegin', hero);
    return true;
  };

  const makeNumberBuilder = () => {
    const productForm = document.querySelector('.js-product-form') || document.querySelector('form[action*="/cart/add"]') || document.querySelector('.product-form form');
    if (!productForm || document.querySelector('.number-builder')) return !!productForm;
    const box = document.createElement('section');
    box.className = 'candy-crush-builder candy-crush-builder__fallback-size number-builder';
    box.innerHTML = `
      <header class="number-builder__header">
        <p>MAKE IT A NUMBER TO REMEMBER</p>
        <h2>Build your Number SmashCake</h2>
        <span>Choose the number, the candy colour story and your chocolate shell.</span>
      </header>
      <fieldset class="number-builder__group number-builder__number">
        <legend>1. Choose your number</legend>
        <label>What are we celebrating?<select name="properties[Number]" required><option value="">Choose a number</option><option value="0">0</option><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option><option value="5">5</option><option value="6">6</option><option value="7">7</option><option value="8">8</option><option value="9">9</option></select></label>
        <small>Each Number SmashCake is one single number.</small>
      </fieldset>
      <fieldset class="number-builder__group">
        <legend>2. Pick your candy topping</legend>
        <div class="number-builder__choices">
          <label class="number-builder__choice"><input type="radio" name="properties[Candy topping]" value="Rainbow" required checked><span class="number-builder__swatch number-builder__swatch--rainbow"></span><strong>Rainbow</strong></label>
          <label class="number-builder__choice"><input type="radio" name="properties[Candy topping]" value="Pink" required><span class="number-builder__swatch number-builder__swatch--pink"></span><strong>Pink</strong></label>
          <label class="number-builder__choice"><input type="radio" name="properties[Candy topping]" value="Blue" required><span class="number-builder__swatch number-builder__swatch--blue"></span><strong>Blue</strong></label>
        </div>
      </fieldset>
      <fieldset class="number-builder__group">
        <legend>3. Choose your chocolate shell</legend>
        <div class="number-builder__choices number-builder__choices--shell">
          <label class="number-builder__choice"><input type="radio" name="properties[Chocolate shell]" value="White chocolate" required checked><span class="number-builder__swatch number-builder__swatch--white"></span><strong>White chocolate</strong></label>
          <label class="number-builder__choice"><input type="radio" name="properties[Chocolate shell]" value="Pink chocolate" required><span class="number-builder__swatch number-builder__swatch--shell-pink"></span><strong>Pink</strong></label>
          <label class="number-builder__choice"><input type="radio" name="properties[Chocolate shell]" value="Blue chocolate" required><span class="number-builder__swatch number-builder__swatch--shell-blue"></span><strong>Blue</strong></label>
          <label class="number-builder__choice"><input type="radio" name="properties[Chocolate shell]" value="Milk chocolate" required><span class="number-builder__swatch number-builder__swatch--milk"></span><strong>Milk</strong></label>
        </div>
      </fieldset>
      <label class="number-builder__notes">Anything else we should know?<textarea name="properties[Notes]" rows="3" placeholder="Allergies or any party details — pop them here."></textarea></label>
      <p class="number-builder__reassurance">Handmade in Melbourne · Includes a wooden hammer + candy-filled surprise.</p>
    `;
    const legacy = () => document.querySelectorAll('.best-custom-product-options, .candy-crush-builder__extras').forEach((element) => {
      element.hidden = true;
      element.setAttribute('aria-hidden','true');
      element.style.setProperty('display','none','important');
    });
    legacy();
    const observer = new MutationObserver(legacy);
    observer.observe(document.documentElement,{childList:true,subtree:true});
    const quantity = productForm.querySelector('[name="quantity"]')?.closest('.quantity-submit-row') || productForm.querySelector('[name="quantity"]');
    if (quantity) quantity.insertAdjacentElement('beforebegin', box);
    else productForm.prepend(box);
    return true;
  };

  const makeSayItBuilder = () => {
    const productForm = document.querySelector('.js-product-form');
    if (!productForm || document.querySelector('.say-it-builder')) return !!productForm;
    const box = document.createElement('section');
    box.className = 'candy-crush-builder candy-crush-builder__fallback-size say-it-builder';
    box.innerHTML = '<header class="say-it-builder__header"><p>MAKE IT PERSONAL</p><h2>What would you like to say?</h2><span>Choose your chocolate colour, then add up to seven characters on each line.</span></header><div class="say-it-builder__message"><label>Line one <input name="properties[Message line 1]" maxlength="7" autocomplete="off" placeholder="HAPPY"></label><label>Line two <input name="properties[Message line 2]" maxlength="7" autocomplete="off" placeholder="BIRTHDAY"></label><small>Maximum 7 characters per line.</small></div>';
    const palette = fallbackPalette('Pick your chocolate colour', 'Choose the colour that makes your message pop.', 'Chocolate colour');
    box.append(palette);
    box.querySelectorAll('.say-it-builder__message input').forEach((input) => {
      input.addEventListener('input', () => { input.value = input.value.toUpperCase().slice(0, 7); });
    });
    const syncSayItColour = () => {
      const chosen = box.querySelector('.candy-crush-builder__option.is-selected span:last-child')?.textContent?.trim();
      const colourInput = box.querySelector('input[name="properties[Chocolate colour]"]');
      if (chosen && colourInput) {
        colourInput.value = chosen;
        colourInput.setAttribute('value', chosen);
      }
    };
    box.addEventListener('click', () => window.setTimeout(syncSayItColour, 0));
    productForm.addEventListener('submit', syncSayItColour, true);
    const quantity = productForm.querySelector('[name="quantity"]')?.closest('.quantity-submit-row') || productForm.querySelector('[name="quantity"]');
    if (quantity) quantity.insertAdjacentElement('beforebegin', box);
    else productForm.prepend(box);
    return true;
  };

  const removeLegacyVariantApp = () => {
    const root = document.querySelector('.best-custom-product-options');
    const cleanBuilder = document.querySelector('.candy-crush-builder__fallback-size');
    if (!root || !cleanBuilder) return false;
    root.remove();
    return true;
  };

  const hideLegacyDomeColours = () => {
    const root = document.querySelector('.best-custom-product-options');
    if (!root) return false;
    root.querySelectorAll('.selector-wrapper.bcpo-colors').forEach((group) => {
      group.hidden = true;
      group.setAttribute('aria-hidden', 'true');
      group.style.setProperty('display', 'none', 'important');
    });
    if (!root.dataset.domeColourCleaner) {
      root.dataset.domeColourCleaner = 'true';
      const observer = new MutationObserver(() => {
        root.querySelectorAll('.selector-wrapper.bcpo-colors').forEach((group) => {
          group.hidden = true;
          group.setAttribute('aria-hidden', 'true');
          group.style.setProperty('display', 'none', 'important');
        });
      });
      observer.observe(root, { childList: true, subtree: true });
    }
    return true;
  };

  const makeExtras = () => {
    const appForm = document.querySelector('.best-custom-product-options form');
    const productForm = document.querySelector('.js-product-form');
    const host = appForm || productForm;
    if (!host || document.querySelector('.candy-crush-builder__extras')) return !!host;

    const existingNotes = appForm && Array.from(appForm.querySelectorAll('.selector-wrapper')).find((group) => {
      return /additional notes|notes you have|anything else/i.test(group.textContent);
    });
    if (existingNotes) {
      const existingTitle = existingNotes.querySelector('.bcpo-title');
      if (existingTitle) existingTitle.textContent = 'Anything else we should know?';
    }

    const box = document.createElement('section');
    box.className = 'candy-crush-builder__extras';
    box.innerHTML = `
      <h3>Would you like to add a little extra?</h3>
      <p>Optional finishing touches, each just $4.</p>
      <label class="candy-crush-builder__extra">
        <input type="checkbox" data-addon="candle">
        <span><strong>Make a Wish</strong><small>Choose the birthday number: 5, 21, 30 or 100.</small></span>
        <span class="candy-crush-builder__extra-price">+$4</span>
        <input class="candy-crush-builder__extra-input" data-input="candle" placeholder="What number are we celebrating?">
      </label>
      <label class="candy-crush-builder__extra">
        <input type="checkbox" data-addon="topper">
        <span><strong>Happy Birthday Topper</strong><small>A little extra party magic.</small></span>
        <span class="candy-crush-builder__extra-price">+$4</span>
      </label>
      <label class="candy-crush-builder__extra">
        <input type="checkbox" data-addon="name">
        <span><strong>Make It Yours</strong><small>Add their name to the SmashCake.</small></span>
        <span class="candy-crush-builder__extra-price">+$4</span>
        <input class="candy-crush-builder__extra-input" data-input="name" placeholder="What name should we write?">
      </label>
      ${existingNotes ? '' : '<label class="candy-crush-builder__notes"><span>Anything else we should know?</span><textarea name="candy_crush_notes" rows="3" placeholder="Allergies, a dream colour or any party details — pop them here."></textarea></label>'}
      <p class="candy-crush-builder__reassurance">Handmade in Melbourne · Includes a wooden hammer + candy-filled surprise.</p>
    `;
    const addToCartButton = (productForm || appForm)?.querySelector('button[type="submit"], input[type="submit"]');
    if (addToCartButton) {
      addToCartButton.insertAdjacentElement('beforebegin', box);
      if (existingNotes) {
        addToCartButton.insertAdjacentElement('beforebegin', existingNotes);
      }
    } else {
      host.insertAdjacentElement('afterend', box);
    }

    box.querySelectorAll('input[type="checkbox"]').forEach((check) => {
      check.addEventListener('change', () => {
        const row = check.closest('.candy-crush-builder__extra');
        row.classList.toggle('is-open', check.checked);
        const field = row.querySelector('.candy-crush-builder__extra-input');
        if (field) field.required = check.checked;
      });
    });

    let addingExtras = false;
    const selectedExtras = () => Array.from(box.querySelectorAll('input[type="checkbox"]:checked'));
    const addExtrasToCart = async () => {
      if (addingExtras) return;
      const selected = selectedExtras();
      if (!selected.length) return;
      const candle = box.querySelector('[data-input="candle"]');
      const name = box.querySelector('[data-input="name"]');
      if (selected.some((check) => check.dataset.addon === 'candle') && !candle.value.trim()) {
        candle.focus();
        return;
      }
      if (selected.some((check) => check.dataset.addon === 'name') && !name.value.trim()) {
        name.focus();
        return;
      }
      if (appForm && !appForm.checkValidity()) {
        appForm.reportValidity();
        return;
      }
      const parentId = appForm?.querySelector('#bcpo-select')?.value || document.querySelector('.candy-crush-builder__size-select')?.value || productForm?.querySelector('[name="id"]')?.value;
      if (!parentId) {
        alert('Please choose your SmashCake size before adding to cart.');
        return;
      }
      addingExtras = true;
      const properties = getProperties(appForm || productForm);
      const notes = box.querySelector('textarea')?.value.trim();
      if (notes) properties['Anything else we should know?'] = notes;
      const variantIds = { candle: '62865479499935', topper: '62865479532703', name: '62865479565471' };
      const items = [{ id: parentId, quantity: 1, properties }];
      selected.forEach((check) => {
        const kind = check.dataset.addon;
        const item = { id: variantIds[kind], quantity: 1, properties: {} };
        if (kind === 'candle') item.properties['Birthday number'] = candle.value.trim();
        if (kind === 'name') item.properties['Name for SmashCake'] = name.value.trim();
        items.push(item);
      });
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('Unable to add extras');
        window.location.assign('/cart');
      } catch (error) {
        addingExtras = false;
        alert('We could not add those extras just now. Please try again.');
      }
    };

    const intercept = (event) => {
      if (!selectedExtras().length) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      addExtrasToCart();
    };
    document.addEventListener('submit', intercept, true);
    document.addEventListener('click', (event) => {
      const submit = event.target.closest('button[type="submit"], input[type="submit"]');
      if (!submit || !selectedExtras().length) return;
      const form = submit.closest('form');
      if (form !== appForm && form !== productForm) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      addExtrasToCart();
    }, true);
    return true;
  };


  if (isNumberCake) {
    ready(makeNumberBuilder);
    ready(mountNumberHero);
    return;
  }

  if (isSayIt) {
    const cleanSayItPage = () => {
      document.querySelectorAll('.best-custom-product-options, .candy-crush-builder__extras').forEach((element) => {
        element.hidden = true;
        element.setAttribute('aria-hidden', 'true');
        element.style.setProperty('display', 'none', 'important');
      });
    };
    ready(() => {
      const built = makeSayItBuilder();
      if (!built) return false;
      cleanSayItPage();
      const sayItCleaner = new MutationObserver(cleanSayItPage);
      sayItCleaner.observe(document.documentElement, { childList: true, subtree: true });
      return true;
    });
    return;
  }

  if (isSmashBox) {
    ready(enhancePalette);
    return;
  }

  if (isDome) {
    ready(() => {
      if (isDomePalette) return enhancePalette() && makeExtras();
      return hideLegacyDomeColours() && makeExtras();
    });
    return;
  }

  ready(() => {
    makeFallbackBuilder().then(() => {
      removeLegacyVariantApp();
      const legacyCleaner = new MutationObserver(removeLegacyVariantApp);
      legacyCleaner.observe(document.documentElement, { childList: true, subtree: true });
    });
    const extrasReady = makeExtras();
    return extrasReady;
  });
})();

